import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useCallback, useEffect } from "react";
import { useApolloClient, useMutation, useLazyQuery } from "@apollo/client";
import { retrieveCartId } from "@magento/peregrine/lib/store/actions/cart";
import { useUserContext } from "@magento/peregrine/lib/context/user";
import { useCartContext } from "../../context/cart";
import DEFAULT_OPERATIONS from "./signIn.gql";
import { useCheckoutContext } from "@magento/peregrine/lib/context/checkout";
import CheckoutPageOperations from "@overrides_venia/venia-ui/components/CheckoutPage/checkoutPage.gql";
export var useCustomerCart = () => {
  var {
    mergeCartsMutation
  } = DEFAULT_OPERATIONS;
  var {
    mutations: {
      calculateLSCartMutation
    },
    queries: {
      getCheckoutDetailsQuery
    }
  } = CheckoutPageOperations;
  var apolloClient = useApolloClient();
  var [{
    cartId
  }, {
    updateCartData
  }] = useCartContext();
  var [{
    token,
    isUserComplete,
    guestCartId
  }, {
    setGuestCartId
  }] = useUserContext();
  var [, {
    submitCheckoutStepCompleted
  }] = useCheckoutContext();
  var [mergeCarts] = useMutation(mergeCartsMutation, {});
  var [calculateLSCart] = useMutation(calculateLSCartMutation, {});
  var [getCheckoutDetails] = useLazyQuery(getCheckoutDetailsQuery, {
    fetchPolicy: "no-cache",
    skip: !cartId,
    onError: error => {
      console.log(error);
    },
    onCompleted: data => {
      updateCartData(data.cart);
    }
  });
  var handleCustomerLogin = useCallback( /*#__PURE__*/_asyncToGenerator(function* () {
    submitCheckoutStepCompleted({
      pickupTime: false,
      shippingAddress: false,
      payment: false,
      review: false,
      tableData: false,
      shippingMethod: false,
      shippingDataSet: false
    });

    // Merge the guest cart into the customer cart.
    yield mergeCarts({
      variables: {
        destinationCartId: cartId,
        sourceCartId: guestCartId
      },
      onCompleted: () => {
        setGuestCartId(null);
      }
    });
    yield calculateLSCart({
      variables: {
        cartId: cartId
      }
    });
    yield getCheckoutDetails({
      variables: {
        cartId: cartId
      }
    });
  }), [cartId, apolloClient, token, mergeCarts]);
  useEffect(() => {
    if (token && isUserComplete && guestCartId && cartId && guestCartId !== cartId) {
      handleCustomerLogin();
    }
  }, [token, isUserComplete, guestCartId, cartId]);
  return null;
};